<template>
  <div
    class="text-static-default-hi font-punchline text-punchline leading-punchline text-center"
  >
    Need help? We gotchu.
  </div>
</template>
